export default "__VITE_ASSET__JGg44ShO__"